export default __webpack_public_path__ + "static/media/about-footer.2dababaf.png";